import { z } from 'zod/v4';

interface WebsocketEndpointProps<
    TPathParams extends z.ZodTypeAny,
    TQueryParams extends z.ZodTypeAny,
    TWebsocketResponseMessage extends z.ZodTypeAny,
> {
    description: string;

    pathParams: TPathParams;

    queryParams: TQueryParams;

    responseMessage: TWebsocketResponseMessage;
}

/** Does nothing at runtime; it only types the endpoint definition. */
export function websocketEndpoint<
    TPathParams extends z.ZodTypeAny,
    TQueryParams extends z.ZodTypeAny,
    TWebsocketResponseMessage extends z.ZodTypeAny,
>({
    description,
    pathParams,
    queryParams,
    responseMessage,
}: WebsocketEndpointProps<TPathParams, TQueryParams, TWebsocketResponseMessage>) {
    return {
        description,
        pathParams,
        queryParams,
        responseMessage,
    };
}
